module.exports = __webpack_public_path__ + "static/media/16th_C.abf4e11f.png";